/* assets/beovea-collection.js */
document.addEventListener('DOMContentLoaded', function() {
  // =========================
  // Helpers
  // =========================
  const getViewParam = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get('view');
  };

  // 构造目标跳转 URL：保留 sort_by + view，删除 page
  const buildNavUrl = (href) => {
    const target = new URL(href, window.location.origin);
    const current = new URL(window.location.href);

    const sortBy = current.searchParams.get('sort_by');
    if (sortBy) target.searchParams.set('sort_by', sortBy);

    const view = getViewParam();
    if (view) target.searchParams.set('view', view);

    target.searchParams.delete('page');
    return target.toString();
  };

  const setBreadcrumb = (label) => {
    const breadcrumbSpan = document.getElementById('beovea-breadcrumb-current');
    if (!breadcrumbSpan) return;
    breadcrumbSpan.textContent = (label === 'SHOP ALL') ? 'ALL' : label;
  };

  // ✅ 刷新后重排：active 放到第一个（SHOP ALL位置），其余依次右移
  const reorderTabs = (activeKey) => {
    const wrap = document.querySelector('.beovea-categories');
    if (!wrap) return;

    // ✅ 你页面的“基础顺序”（刷新后会以这个顺序为模板来重排）
    const ORDER = ['shop-all', 'bestsellers', 'face-body', 'makeup', 'sets-kits'];

    const map = {};
    wrap.querySelectorAll('a[data-key]').forEach(a => {
      map[a.getAttribute('data-key')] = a;
    });

    const newOrder = [activeKey, ...ORDER.filter(k => k !== activeKey)];
    newOrder.forEach(k => {
      if (map[k]) wrap.appendChild(map[k]); // appendChild 会移动节点位置（不会复制）
    });
  };

  // ✅ 非 SHOP ALL 时，只显示第二排
  const applyGridLayoutByTab = (activeKey) => {
    const gridEl = document.querySelector('.beovea-grid');
    if (!gridEl) return;

    const rows = Array.from(gridEl.querySelectorAll('.beovea-row'));
    if (rows.length < 2) return;

    if (activeKey === 'shop-all') {
      rows[0].style.display = '';
      rows[1].style.display = '';
    } else {
      rows[0].style.display = 'none';
      rows[1].style.display = '';
    }
  };

  const bindAjaxATC = (scope) => {
    (scope || document).querySelectorAll('.beovea-add-btn[data-variant-id]').forEach((btn) => {
      if (btn.__beoveaBound) return;
      btn.__beoveaBound = true;

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });

          if (!res.ok) throw new Error('Add to cart failed');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (err) {
          console.error(err);
          alert('Sorry, failed to add to cart.');
        } finally {
          btn.disabled = false;
        }
      });
    });
  };

  // =========================
  // Sort dropdown (keep current)
  // =========================
  const sortBtn = document.getElementById('beovea-sort-btn');
  const sortDropdown = document.getElementById('beovea-sort-dropdown');
  const sortOptions = document.querySelectorAll('.beovea-sort-option');

  const closeDropdown = () => {
    if (!sortDropdown) return;
    sortDropdown.classList.remove('open');
    if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
  };

  if (sortBtn && sortDropdown) {
    sortBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = sortDropdown.classList.toggle('open');
      sortBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', function(e) {
      if (!sortBtn.contains(e.target) && !sortDropdown.contains(e.target)) closeDropdown();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDropdown();
    });

    sortOptions.forEach(option => {
      option.addEventListener('click', function() {
        const value = this.getAttribute('data-value');
        if (!value) return;

        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.toString(); // ✅整页刷新
      });
    });
  }

  // =========================
  // Category tabs: FULL PAGE RELOAD navigation
  // =========================
  const categoriesWrap = document.querySelector('.beovea-categories');

  if (categoriesWrap) {
    // 先找当前 active tab
    const active = categoriesWrap.querySelector('a.active[data-key]');
    const activeKey = active ? active.getAttribute('data-key') : 'shop-all';
    const activeLabel = active ? (active.textContent || '').trim() : 'SHOP ALL';

    // ✅ 刷新后：面包屑 + 重排 + 行显示逻辑
    setBreadcrumb(activeLabel);
    reorderTabs(activeKey);
    applyGridLayoutByTab(activeKey);

    // 点击：整页刷新跳转（保留 sort_by / view）
    categoriesWrap.querySelectorAll('a[data-key]').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();

        const href = a.getAttribute('href');
        if (!href) return;

        const targetUrl = buildNavUrl(href);
        window.location.href = targetUrl;
      });
    });
  } else {
    // 没有 tabs 也照样保证布局逻辑
    applyGridLayoutByTab('shop-all');
  }

  // initial bind
  bindAjaxATC(document);
});